import { useDispatch } from "react-redux";
import { useCheckPermission } from "../../../../hooks/useCheckPermission";
import {
  setEnabledQuery,
  setReportsSingleClientReport,
  setTotalCountSingleClientReport,
  useSelectEnabledSingleClientReport,
  useSelectFiltersSingleClientReport,
  useSelectPageSingleClientReport,
  useSelectSizeSingleClientReport,
  useSelectTotalCountSingleClientReport,
} from "../../../../redux/features/reports/singleClientReportSlice";
import { getReports } from "../../../../services/report";
import { useQuery } from "@tanstack/react-query";
import { formatFiltersReports } from "../utils";

const useSingleClientReportFilters = () => {
  const dispatch = useDispatch();
  const filters = useSelectFiltersSingleClientReport();
  const exportPermission = useCheckPermission("DOWNLOAD_REPORT");

  const page = useSelectPageSingleClientReport();
  const size = useSelectSizeSingleClientReport();
  const totalCount = useSelectTotalCountSingleClientReport();
  const enabled = useSelectEnabledSingleClientReport();

  const setEnabled = (val) => dispatch(setEnabledQuery(val));

  const { isLoading, refetch } = useQuery({
    queryKey: [
      "get-single-client-report",
      page,
      size,
      formatFiltersReports(filters),
    ],
    queryFn: () => getReports(page, size, formatFiltersReports(filters)),
    refetchOnWindowFocus: false,
    enabled: enabled,
    select: (data) => {
      const { elements, data: reports } = data;
      dispatch(setTotalCountSingleClientReport(elements));
      dispatch(setReportsSingleClientReport(reports));
    },
  });

  return {
    page,
    size,
    totalCount,
    exportPermission,
    isLoading,
    enabled,
    getReports: refetch,
    setEnabled,
  };
};

export default useSingleClientReportFilters;
